export default __webpack_public_path__ + "static/media/04_Prase_divoke_Migos_cmmmj_thumb-min.751b9f82.jpg";